import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { withRouter } from "react-router-dom";
import  Page  from '../../components/Page';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, AddSurvey,Addanswers,Answers } from './components';
import {
  Button,
  Dialog,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function showSnack(snackbarCtx, type, msg) {
  snackbarCtx.setSnack({
    ...snackbarCtx,
    open: true,
    type,
    msg,
    vertical: "top",
  });
}

function surveyLanguagesForSave(languages) {
  return (languages || []).filter((lang) => lang && lang.name !== 'All' && String(lang.id) !== '0');
}

function validateSurveyForm(params, useranswer) {
  const languages = surveyLanguagesForSave(params.languages);
  if (!languages.length) {
    return 'Select at least one language';
  }
  if (!params.surveytype || params.surveytype.value == null) {
    return 'Select a survey type';
  }
  for (let i = 0; i < languages.length; i += 1) {
    const lang = languages[i];
    const text = params[lang.name];
    if (text == null || String(text).trim() === '') {
      return `Enter question text for ${lang.name}`;
    }
  }
  if (params.surveytype.name === 'Choice' || params.surveytype.value === 1) {
    if (!useranswer || useranswer.length < 2) {
      return 'Choice survey requires at least 2 answers/options';
    }
    for (let i = 0; i < useranswer.length; i += 1) {
      const ans = useranswer[i];
      for (let j = 0; j < languages.length; j += 1) {
        const lang = languages[j];
        const text = ans[`answer${lang.name}`];
        if (text == null || String(text).trim() === '') {
          return `Option ${i + 1}: enter text for ${lang.name}`;
        }
      }
    }
  }
  return null;
}

export const EditSurvey = withRouter(props => {
  const history = useHistory();
  const classes = useStyles();
  const [newsobj, setNewsobj] = useState({});
  const [viewtype, setViewtype] = useState(1);
  const [selectedanswer, setSelectedanswer] = useState(null);
  const [isaddanswer, setIsaddanswer] = useState(false);
  const [params, setParams] = useState({});
  const [useranswer, setUseranswer] = useState([]);
  const [saving, setSaving] = useState(false);

  const [masters, setMasters] = useState({
    commodity :[],
    languages:[],
    surveyType: []
  });

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);

  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    let surveyType = [{ name: "Choice", value: 1 }, { name: "Free Text", value: 2 }]
    const activeLanguages = (languages.module || []).filter((lang) => lang && lang.name !== 'All' && String(lang.id) !== '0');
    setMasters({
      ...masters,
      languages : [{ id: 0, name: 'All', status: true }, ...activeLanguages],
      commodity : commodities.module,
      surveyType : surveyType
    })

    var com_id = props.location.pathname.split('/')[2];
    if(com_id){
      fetchsurveyinfo(com_id,activeLanguages,commodities.module,surveyType);
    }
  }
  async function updatenewsinfo()
  {
    const validationError = validateSurveyForm(params, useranswer);
    if (validationError) {
      showSnack(snackbarCtx, 'error', validationError);
      return;
    }
    const isChoice = params?.surveytype?.value === 1 || params?.surveytype?.name === 'Choice';
    const languages = surveyLanguagesForSave(params.languages);
    let bodycontent = {
      question :  {...params, languages, surveytype: params?.surveytype?.value??null},
      answer : isChoice ? useranswer : [],
      id : newsobj.id,
    }
    setSaving(true);
    try {
      let response = await sendNetworkRequest('/admin/addsurvey', {}, bodycontent, false, true);
      if (!response || response.statusCode >= 400 || response.status === 'error') {
        showSnack(snackbarCtx, 'error', response?.message || 'Failed to save survey');
        return;
      }
      showSnack(snackbarCtx, 'success', 'Saved Successfully');
      history.push('/survey');
    } finally {
      setSaving(false);
    }
  }
  const handleaddanswer = (index) => {
    if(index > -1)
    {
      setSelectedanswer({
        ...useranswer[index],
        index
      })
    } else {
      const maxOrder = useranswer.reduce((max, ans) => {
        const n = parseInt(ans.sortorder, 10);
        return Number.isFinite(n) ? Math.max(max, n) : max;
      }, 0);
      setSelectedanswer({
        sortorder: maxOrder + 1
      })
    }
    setIsaddanswer(!isaddanswer)
  }
  const handleDeleteAnswer = (index) => {
    setUseranswer((prev) => prev.filter((_, i) => i !== index));
  };
  const handleToggleComment = (index, checked) => {
    setUseranswer((prev) => prev.map((ans, i) => (
      i === index ? { ...ans, is_comment: checked } : ans
    )));
  };
  const handleClear = () => {
    if (newsobj && newsobj.id) {
      setParams({
        id: newsobj.id,
        imageurl: newsobj.imageurl,
        commodity: newsobj.commodity || [],
        languages: newsobj.languages || [],
        surveytype: newsobj.surveytype || null,
        ...Object.keys(newsobj).reduce((acc, key) => {
          if (newsobj.languages && newsobj.languages.some((l) => l.name === key)) {
            acc[key] = newsobj[key];
          }
          return acc;
        }, {}),
      });
      // reload options from last saved newsobj snapshot is not stored separately;
      // keep current answers unless user confirms — for Clear, reset answers only if create
      showSnack(snackbarCtx, 'success', 'Form fields restored from last loaded survey');
    } else {
      setParams({});
      setUseranswer([]);
      setNewsobj({});
    }
  };
  async function fetchsurveyinfo(newsid,lang,mas_commodities, surveyType)
  {

    let commodities = await sendNetworkRequest('/admin/getsurveyinfo', {}, {id:newsid},false)

    let survey_obj = commodities.module;
    let survey_lang = survey_obj.languages;
    let survey_commodities = survey_obj.commodities;
    let commodity  = []
    if(mas_commodities){

      mas_commodities.map(m_com => {
        if(survey_commodities.indexOf(""+m_com.id) > -1)
        {
          commodity.push(m_com)
        }
      })
    }

    let langs = []
      if(lang){
        lang.map (obj => {
          if(survey_lang.indexOf(""+obj.id) > -1){
            langs.push(obj)
          }
        })
      }

      let questions = {}

      if(survey_obj.survey_questions){
        if(survey_obj.survey_questions.length > 0){
          const rawQuestion = survey_obj.survey_questions[0].question;
          if (typeof rawQuestion === 'string') {
            try { questions = JSON.parse(rawQuestion) || {}; } catch (e) { questions = {}; }
          } else if (rawQuestion && typeof rawQuestion === 'object') {
            questions = rawQuestion;
          }
        }
      }

      let surveytype = null;
      if(surveyType){
        surveytype = surveyType.filter(val => val.value === (survey_obj.answer_type || 1))[0]
      }
     let newsobj = {
             id : survey_obj.id,
             imageurl: survey_obj.imageurl,
            ...questions,
            surveytype: surveytype,
            commodity : commodity,
            languages : langs
       }

       let user_options = []
       let useranswer_arr = (survey_obj.survey_options || []).filter((obj) => obj.status !== false);
       useranswer_arr.map(obj => {
        let usr_obj = {
            ...obj,

        }
        const langOptions = obj.lang_options && typeof obj.lang_options === 'object'
          ? obj.lang_options
          : {};
        Object.keys(langOptions).map(key => {
          usr_obj[`answer${key}`] = langOptions[key];
        })
        user_options.push(usr_obj)
       })
       user_options.sort((a, b) => {
        const sa = a.sortorder != null ? a.sortorder : 9999;
        const sb = b.sortorder != null ? b.sortorder : 9999;
        if (sa !== sb) return sa - sb;
        return (a.id || 0) - (b.id || 0);
       })


      setNewsobj(newsobj)
      setUseranswer(user_options)
      setParams({
        id : survey_obj.id,
        mageurl: survey_obj.imageurl,
        commodity : commodity,
        languages : langs,
        surveytype: surveytype,
        ...questions,
      })


   
  }
  useEffect(() => {
    fetchmasters()
 
   
  }, []);
  function handleoptionchange(type, value)  {
    setParams(params => {
      const next = {
        ...params,
        [type]: value
      };
      // Switching to Free Text clears local options (backend soft-deletes on save).
      if (type === 'surveytype' && value && (value.value === 2 || value.name === 'Free Text')) {
        setUseranswer([]);
      }
      return next;
    });
  }
  function handleanswer(value)  {
    const languages = surveyLanguagesForSave(params.languages);
    for (let i = 0; i < languages.length; i += 1) {
      const lang = languages[i];
      const text = value[`answer${lang.name}`];
      if (text == null || String(text).trim() === '') {
        showSnack(snackbarCtx, 'error', `Enter option text for ${lang.name}`);
        return;
      }
    }
    const parsedOrder = parseInt(value.sortorder, 10);
    const nextValue = {
      ...value,
      sortorder: Number.isFinite(parsedOrder) ? parsedOrder : useranswer.length + 1
    }
    let answers = []
    if(selectedanswer && selectedanswer.index != null)
    {
     
      useranswer.map((ans, index) => {
        if(index == selectedanswer.index)
        {
          answers.push(nextValue)
        }else{
          answers.push(ans)
        }
      })
    }else{
      answers = [...useranswer]
      answers.push(nextValue)
  
    }
    answers.sort((a, b) => {
      const sa = a.sortorder != null ? a.sortorder : 9999;
      const sb = b.sortorder != null ? b.sortorder : 9999;
      if (sa !== sb) return sa - sb;
      return (a.id || 0) - (b.id || 0);
    })
    
    setUseranswer(answers)
    setSelectedanswer(null)
    setIsaddanswer(false)
  }
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <AddSurvey usercontent={newsobj} masters={masters} viewtype={viewtype} 
        onValuechange={handleoptionchange}
      />
    {params?.surveytype?.name === "Choice" &&
      <Answers 
        languages={params.languages ? params.languages : []}
        surveyanswers={useranswer}
        usercontent={newsobj} 
        masters={masters} 
        viewtype={viewtype}
        onAddanswer={handleaddanswer}
        onDeleteanswer={handleDeleteAnswer}
        onToggleComment={handleToggleComment}
      /> 
    }
     <Dialog  aria-labelledby="customized-dialog-title" open={isaddanswer} >
        <DialogTitle id="customized-dialog-title"  onClose={handleaddanswer}>
          Modal title
        </DialogTitle>
        <DialogContent dividers>

     <Addanswers languages={params.languages ? params.languages : []}   usercontent={selectedanswer} masters={masters} viewtype={viewtype} 
      onValuechange={handleanswer}
     /> 
     </DialogContent>
     </Dialog>
      <div className={classes.actions}>
          <Button
            style={{ marginRight: 14 }}
            onClick={handleClear}
            variant="contained"
            disabled={saving}
          >
            Clear
          </Button>

          <Button
            
            color="primary"
            type="submit"
            variant="contained"
            onClick={updatenewsinfo}
            disabled={saving}
          >
            {saving ? 'Saving…' : 'Update'}
          </Button>
        </div>
    </Page>
  );
});

export default EditSurvey;
